import AppReactotron from "./AppReactotron";

const appReactotron = new AppReactotron();
export const createEnhancer = appReactotron.reactotronReactNative.createEnhancer;
export const setReduxStore = appReactotron.reactotronReactNative.setReduxStore!;
